<template>

  <v-btn-toggle
    v-model="billingTab"
    mandatory
    color="primary"
    background-color="white"
  >
    <v-btn small class="px-2" value="account" :to="{ name: 'billing/account' }">Account</v-btn>
    <v-btn small class="px-2" value="history" :to="{ name: 'billing/history' }">History</v-btn>
    <v-btn small class="px-2" value="statements" :to="{ name: 'billing/statements' }">Statements</v-btn>
    <v-btn small class="px-2" value="payments" :to="{ name: 'billing/payments' }">Payments</v-btn>
  </v-btn-toggle>

</template>

<script>
export default {
  name: 'BillingTabs',

  data: () => ({
    billingTab: 'account'
  }),
}
</script>